<template>
    <div class="picker picLoad"
        :class="mustFlag">
        <h6><span></span>图片上传</h6>
        <div class="text" :style="{'padding-bottom' : padding , 'position' : 'relative'}">
            <div class='pic_box pic_up_box' >
                <div 
                    v-for='(item ,index ) in imgBase' 
                    class='room_img' 
                    :key=index
                    v-show="imgBaseTag">
                    <img :src="item">
                    <span 
                        @click='delete_img(index)' 
                        class="icon"
                    ></span>
                </div> 
                <div class='room_add_img' v-show="imgLoadTag">
                    <span class="icon"></span>
                    <span class="add_mess">添加图片</span>
                    <input 
                        @change='getMess' 
                        type="file" 
                        multiple = "multiple"
                        accept="image/jpg, image/jpeg, image/png, image/bmp">
                </div>
            </div>
            <div class='pic_box pic_load_pic' >
                <div 
                    v-for='(item ,index ) in imgLoad' 
                    class='room_img' 
                    :key=index>
                    <p class="loading"><i class="load-icon"></i>上传中...</p>
                    <img :src="item">
                </div> 
                <div class='room_add_img' v-show="picLoad">
                    <span class="icon"></span>
                    <span class="add_mess">添加图片</span>
                    <input 
                        @change='getMess' 
                        type="file" 
                        multiple = "multiple"
                        accept="image/jpg, image/jpeg, image/png, image/bmp">
                </div>
            </div>
            <p class="intro__pic-mess"><em>{{picCount}}</em>/5张(每张大小不超过10M)</p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getPicLoad} from '../api/request.js'
	export default {
        props: ["mustFlag"],
        data(){
            return{
                imgBase : [],
                imgLoad : [],
                imgLoadTag : true,
                imgBaseTag : false,
                picCount : 0,  
                imgUrl : [],           
                picLoad : true,
                reader : new FileReader(),
                padding : '25px'
            }
        },
        methods:{
            delete_img(item){
                this.imgBase.splice(item,1)
                this.imgUrl.splice(item,1)
                this.picCount -= 1;
                this.imgLoad.length = this.imgLoad.length - 1
                if(this.picCount == 5){
                    this.picLoad = false
                    this.imgLoadTag = false
                    this.padding = '25px'
                }else{
                    this.padding = '25px'
                    this.picLoad = true
                    this.imgLoadTag = true
                }
            },
            async getMess(event){
                let files = event.target.files
                let len = files.length
                let pic_length = this.picCount
                let len_all = parseInt(pic_length + len);
                if (len > 5 || pic_length > 5 || len_all > 5) {
                    this.$toast('请上传五个以内的证据');
                    return
                }
                this.imgLoad = []
                for(var i = 0 ; i < len_all; i++){
                    this.imgLoad.push('')
                }
                if(len_all >= 4){
                    this.padding = '105px'
                }else{
                    this.padding = '25px'
                }
                const readFileAsync = file => new Promise(resolve => {
                    this.reader.onload = evt => resolve(evt.target.result)
                    this.reader.readAsDataURL(file)
                })    
                for(let i = 0 ; i < len ; i++){ 
                    let img1=event.target.files[i];
                    let fileSize = img1.size
                    if(fileSize > 10485760){
                        this.$toast('上传文件不能大于10M')
                        this.imgLoad.length = this.imgLoad.length - 1
                        len_all -=1 
                        return
                    }
                    let url = await readFileAsync(files[i])
                    this.reader.onloadend= async ()=>{
                        if(this.imgUrl.length != 0){
                            this.imgBaseTag = true
                        }else{
                            this.imgBaseTag = false
                        }
                        this.imgLoadTag = true   
                        this.picCount += 1;
                        this.picLoad = true
                        this.imgLoadTag = true
                        let picPostData = url.replace(/data.*;base64,/, "")
                        // 请求需传递的参数
                        let size = "0 * 0"
                        let data = picPostData
                        let encode = "base64"
                        let path ="/vote/big/"
                        let res = await getPicLoad(size , data , encode , path)
                        this.imgUrl.push(res)
                        this.imgBase.push(url) 
                        if(this.imgUrl.length != ''){
                            this.imgBaseTag = true
                        }else{
                            setTimeout(() => {
                                this.imgBaseTag = true
                            }, 2000);
                        } 
                        if(this.imgBase.length >= 4){
                            setTimeout(() => {
                                this.padding = '25px'
                            }, 50);
                        }
                        if(this.imgBase.length == 5){
                            setTimeout(() => {
                                this.picLoad = false
                                this.imgLoadTag = false
                            }, 500);
                        }
                        this.$emit('transMess' , ['imgUrl' , this.imgUrl])
                    }
                }
                this.imgLoadTag = true
            }
        }		  
    }
</script>

<style scoped>
    .picLoad .main .text ,h6{
        width: 100%;
    }
	.picLoad{
        margin-left: 15px;
        padding-bottom: 5px;
        width: auto;
        border-bottom: 1px solid #EAEAEA;
        line-height: 0;
    }
    .picLoad .intro__pic-mess{
        position: absolute;
        bottom: 0;
        right: 0;
        margin-right: 15px;
        margin-bottom: 5px;
        margin-top: 6px;
        text-align: right;
        font-family: "PingFangSC-Regular";
        font-size: 10px;
        color: #AAA;
        line-height: 12px;
    }
    .pic_box{
        position: relative;
        z-index: 20;
        margin-right: 15px;
        height: auto;
        overflow: hidden;
   }  
   .pic_box div{
       float: left;
        margin: 5px 5px 0 0;
        position: relative;
        font-size: 0;
        background: rgba(246,246,246,0.50);
        border: 1px solid #EAEAEA !important;
        border-radius: 1px;
        width: 77px;
        height: 77px;
   }
   .pic_load_pic{
        position: absolute;
        top: 0;
        z-index: 10;
   }
   .room_add_img input{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 9;
        opacity: 0;
    }
    .room_add_img .icon{
        display: block;
        margin: 30% auto 0;
        width: 13px;
        height: 12px;
        background-image: url(//img.58cdn.com.cn/resource/xxzl/voteCpnfigure_hy/img/icon_pic.png);
        background-size: 13px;
        background-repeat: no-repeat;
        z-index: 101;
    }
    .room_add_img .add_mess{
        display: block;
        text-align: center;
        font-family: "PingFangSC-Regular";
        font-size: 12px;
        color: #AAA;
    }
    .room_img{
        position: relative;
    }
    .room_img img{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 100;
    }
    .room_img .icon{
        display: block;
        position: absolute;
        float: right;
        right: 3px;
        top: 3px;
        width: 15px;
        height: 15px;
        background-image: url(//img.58cdn.com.cn/resource/xxzl/new_vote/m/btn_dele.png);
        background-size: 15px;
        background-repeat: no-repeat;
        z-index: 101;
    }
    .loading{
        width: 80px;
        height: 16px;
        line-height: 16px;
        position: absolute;
        bottom: 33px;
        left: 0;
        color: #999;
        font-size: 14px;
    }
    .load-icon{
        padding-left: 16px;
        background: url(//img.58cdn.com.cn/resource/xxzl/tsimg/loading.gif) no-repeat;
    }
    .pic_up_box .room_add_img{
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/PicLoad/PicLoad.vue